/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import { useParams } from 'react-router'
import { fetchLeaseTemplate } from '../../../lib/rest/leaseTemplateAPIClient'
import PageTitle from '../../../../../client/js/components/PageTitle'
import LeaseTemplateForm from './LeaseTemplateForm'
import { useQuery } from '@tanstack/react-query'
import LoadingHelper from '../../../../../client/js/components/LoadingHelper'
import { Card, Container } from '@mantine/core'
import Page from '../../../../../client/js/components/Page'
import AnchorLink from '../../../../../client/js/components/AnchorLink'
import BreadcrumbCard from '../../../../../client/js/components/breadcrumb/BreadcrumbCard'
import AdminBreadcrumb from '../../../../../client/js/components/breadcrumb/AdminBreadcrumb'
import { getLeaseListLink } from '../../../lib/links/leaseLinks'
import { getLeaseTemplateListLink } from '../../../lib/links/leaseTemplateLinks'

function LeaseTemplateFormPage () {
  const intl = useIntl()
  const params = useParams<{ id?: string }>()
  const templateId = parseInt(params.id, 10)

  const templateQuery = useQuery({
    enabled: true,
    queryKey: ['leaseTemplate', templateId],
    queryFn: () => templateId > 0
      ? fetchLeaseTemplate(templateId)
      : Promise.resolve({} as Partial<LeaseTemplate>),
    refetchOnWindowFocus: false
  })
  const { data } = templateQuery

  const title = templateId > 0 && data
    ? data.name
    : intl.formatMessage({
      id: 'create_lease_template',
      defaultMessage: 'Créer un modèle de bail'
    })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <BreadcrumbCard>
          <AdminBreadcrumb>
            <AnchorLink to={getLeaseListLink()}>
              <FormattedMessage
                id="rental_files"
                defaultMessage="Dossiers de location"
              />
            </AnchorLink>
            <AnchorLink to={getLeaseTemplateListLink()}>
              <FormattedMessage
                id="lease_templates"
                defaultMessage="Modèles de bail"
              />
            </AnchorLink>
            <span>{title}</span>
          </AdminBreadcrumb>
        </BreadcrumbCard>

        <Card shadow="sm">
          <LoadingHelper
            query={templateQuery}
            render={() => (
              <LeaseTemplateForm initialValues={data} />
            )}
          />
        </Card>
      </Container>
    </Page>
  )
}

export default LeaseTemplateFormPage
